  // Article featured image
  $('.text-media--youtube .btn--video').click(function () {
    let figure = $(this).parent();
    let container = figure.parent();
    let iframeWrapper = container.children('.iframe-wrapper');
    let video = iframeWrapper.find('iframe');
    let videoURL = video.attr('src');

    iframeWrapper.fadeIn();
    figure.hide();
    video.attr('src' , video.attr('src') + "?rel=0&modestbranding=1&autoplay=1&mute=1");
  });

  // Internal video: same behavior as YouTube/Vimeo
  $('.text-media--video .btn--video').click(function () {
    let wrapper = $(this).closest('.video-internal-wrapper');
    wrapper.find('.video-poster').hide();
    let video = wrapper.find('video.internal-video');
    video.show();
    video[0].play();
  });
